module.exports = __webpack_public_path__ + "img/Cafe Grazie.54aa3b89.svg";